import React, { useEffect, useState } from 'react';
import './FranchisePage.css';

function FranchisePage() {
  const [menuOpen, setMenuOpen] = useState(false);
  const [scrolled, setScrolled] = useState(false);

  useEffect(() => {
    // Fonts
    const f = document.createElement('link');
    f.href = 'https://fonts.googleapis.com/css2?family=Inter:wght@300;400;500;600;700;800&family=Poppins:wght@400;500;600;700;800&display=swap';
    f.rel = 'stylesheet';
    document.head.appendChild(f);

    // Icons
    const fa = document.createElement('link');
    fa.href = 'https://cdnjs.cloudflare.com/ajax/libs/font-awesome/6.4.0/css/all.min.css';
    fa.rel = 'stylesheet';
    document.head.appendChild(fa);

    window.scrollTo(0, 0);

    const onScroll = () => setScrolled(window.scrollY > 40);
    window.addEventListener('scroll', onScroll);

    const els = document.querySelectorAll('.fp .reveal, .fp .reveal-left, .fp .reveal-right');
    const obs = new IntersectionObserver(
      (entries) => entries.forEach((e) => { if (e.isIntersecting) e.target.classList.add('shown'); }),
      { threshold: 0.06, rootMargin: '0px 0px -30px 0px' }
    );
    els.forEach((el) => obs.observe(el));

    return () => { window.removeEventListener('scroll', onScroll); obs.disconnect(); };
  }, []);

  const go = (e, id) => {
    e.preventDefault();
    document.querySelector(id)?.scrollIntoView({ behavior: 'smooth' });
    setMenuOpen(false);
  };

  return (
    <div className="fp">

      {/* ── NAV ── */}
      <nav className={`topbar ${scrolled ? 'stuck' : ''}`}>
        <a href="#fp-hero" className="topbar-logo" onClick={(e) => go(e, '#fp-hero')}>
          <img src="https://vahaan-buy-and-sell-category-images.s3.ap-south-1.amazonaws.com/VahaanBazar_Image.png" alt="VahaanBazar" />
        </a>
        <ul className={`topbar-nav ${menuOpen ? 'open' : ''}`}>
          <li><a href="#fp-about" onClick={(e) => go(e, '#fp-about')}>About</a></li>
          <li><a href="#fp-svc" onClick={(e) => go(e, '#fp-svc')}>Services</a></li>
          <li><a href="#fp-mkt" onClick={(e) => go(e, '#fp-mkt')}>Market</a></li>
          <li><a href="#fp-mod" onClick={(e) => go(e, '#fp-mod')}>Models</a></li>
          <li><a href="#fp-inv" onClick={(e) => go(e, '#fp-inv')}>Investment</a></li>
          <li><a href="#fp-cta" className="topbar-cta" onClick={(e) => go(e, '#fp-cta')}>Apply Now</a></li>
        </ul>
        <button className="topbar-toggle" onClick={() => setMenuOpen(!menuOpen)}>
          <i className={menuOpen ? 'fas fa-times' : 'fas fa-bars'}></i>
        </button>
      </nav>

      {/* ── HERO ── */}
      <section className="hero" id="fp-hero">
        <div className="hero-inner">
          <div className="hero-eyebrow hero-anim">
            <span>Franchise Opportunities</span>
          </div>
          <h1 className="hero-anim">Partner with India's trusted <em>used vehicle marketplace</em></h1>
          <p className="hero-lead hero-anim">
            Join VahaanBazar as a franchise partner and build a profitable business in the
            booming used commercial vehicle & construction equipment market.
          </p>
          <div className="hero-nums hero-anim">
            <div className="hero-num">
              <strong>&#8377;5,800Cr+</strong>
              <span>Market Size</span>
            </div>
            <div className="hero-num">
              <strong>300%</strong>
              <span>ROI Potential</span>
            </div>
            <div className="hero-num">
              <strong>10-12</strong>
              <span>Month Break-even</span>
            </div>
            <div className="hero-num">
              <strong>25+</strong>
              <span>Locations</span>
            </div>
          </div>
          <div className="hero-btns hero-anim">
            <a href="#fp-cta" className="btn btn-dark" onClick={(e) => go(e, '#fp-cta')}>
              <i className="fas fa-arrow-right"></i> Get Started
            </a>
            <a href="#fp-mod" className="btn btn-soft" onClick={(e) => go(e, '#fp-mod')}>
              <i className="fas fa-th-large"></i> Explore Models
            </a>
          </div>
        </div>
      </section>

      {/* ── ABOUT ── */}
      <section className="sec about-sec" id="fp-about">
        <div className="wrap">
          <div className="about-grid">
            <div className="about-text reveal-left">
              <div className="sec-header">
                <span className="sec-eyebrow">About The Company</span>
                <h2 className="sec-title">Technology meets <em>trust in automobiles</em></h2>
              </div>
              <p>
                At Vahaan Bazar, we are transforming the way used vehicles are bought and sold.
                By combining digital innovation with local market expertise, we provide a trusted
                automobile marketplace that ensures transparency, convenience, and value for every customer.
              </p>
              <p>
                We go beyond simple vehicle listings — offering a complete resale ecosystem that includes
                verified vehicles, real-time pricing, financing, insurance, RTO transfers, and operational support.
              </p>
              <p>
                Our goal is to make buying or selling a vehicle seamless, reliable, and stress-free.
                With a growing presence across regions, Vahaan Bazar empowers customers, dealers, and
                franchise partners to leverage technology, trust, and service excellence.
              </p>
              <div className="about-quote">
                Where Technology Meets Trust in Automobiles.
              </div>
            </div>
            <div className="about-visual reveal-right">
              <div className="about-card-main">
                <img src="https://vahaan-buy-and-sell-category-images.s3.ap-south-1.amazonaws.com/VahaanBazar_Image.png" alt="VahaanBazar" />
                <h3>Complete Resale Ecosystem</h3>
                <p>
                  Verified vehicles, real-time pricing, financing, insurance, RTO transfers
                  & operational support — all in one platform.
                </p>
              </div>
              <div className="about-mini-cards">
                <div className="about-mini">
                  <i className="fas fa-mobile-alt"></i>
                  <strong>6</strong>
                  <span>App Modules</span>
                </div>
                <div className="about-mini">
                  <i className="fas fa-map-marker-alt"></i>
                  <strong>Pan-India</strong>
                  <span>Coverage</span>
                </div>
                <div className="about-mini">
                  <i className="fas fa-headset"></i>
                  <strong>24/7</strong>
                  <span>Support</span>
                </div>
                <div className="about-mini">
                  <i className="fas fa-check-circle"></i>
                  <strong>10K+</strong>
                  <span>Active Users</span>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* ── SERVICES ── */}
      <section className="sec svc-sec" id="fp-svc">
        <div className="wrap">
          <div className="sec-header centered reveal">
            <span className="sec-eyebrow">Our Services</span>
            <h2 className="sec-title">A complete <em>service ecosystem</em></h2>
            <p className="sec-sub">12 integrated services that power our franchise model and drive multiple revenue streams</p>
          </div>
          <div className="svc-grid">
            {[
              { icon: 'fa-gavel', label: 'Auctions' },
              { icon: 'fa-exchange-alt', label: 'Buy & Sell' },
              { icon: 'fa-hand-holding-usd', label: 'Finance' },
              { icon: 'fa-shield-alt', label: 'Insurance' },
              { icon: 'fa-search-dollar', label: 'Inspection & Valuation' },
              { icon: 'fa-exclamation-triangle', label: 'Breakdown' },
              { icon: 'fa-briefcase', label: 'Work / Load' },
              { icon: 'fa-id-card', label: 'Driver / Operator' },
              { icon: 'fa-tools', label: 'Service' },
              { icon: 'fa-cogs', label: 'Spares' },
              { icon: 'fa-random', label: 'Cross Selling' },
              { icon: 'fa-tachometer-alt', label: 'FMS' },
            ].map((s, i) => (
              <div className={`svc-item reveal s${i + 1}`} key={i}>
                <i className={`fas ${s.icon}`}></i>
                <span>{s.label}</span>
              </div>
            ))}
          </div>
        </div>
      </section>

      {/* ── MARKET SIZE ── */}
      <section className="sec mkt-sec" id="fp-mkt">
        <div className="wrap">
          <div className="sec-header centered reveal">
            <span className="sec-eyebrow">Market Opportunity</span>
            <h2 className="sec-title">Commercial Vehicle & <em>Construction Equipment</em></h2>
            <p className="sec-sub">Market Size in Andhra Pradesh & Telangana</p>
          </div>
          <p className="mkt-note reveal">Data based on RTO/Vahan, FY22-FY25, 3 FY's Growth.</p>
          <div className="mkt-cols">
            <div className="mkt-card reveal-left">
              <div className="mkt-card-head">
                <i className="fas fa-map-marker-alt"></i>
                <h3>Andhra Pradesh</h3>
              </div>
              <div className="mkt-card-body">
                <div className="mkt-row">
                  <span className="mkt-row-label">Commercial Vehicles</span>
                  <span className="mkt-row-val">30K <i className="fas fa-long-arrow-alt-right"></i> 36K units</span>
                </div>
                <div className="mkt-row">
                  <span className="mkt-row-label">Construction Equipment</span>
                  <span className="mkt-row-val">700 <i className="fas fa-long-arrow-alt-right"></i> 950 units</span>
                </div>
                <div className="mkt-total">
                  <span>Total Value</span>
                  <strong>&#8377;2,575 Cr → &#8377;3,117.5 Cr</strong>
                </div>
              </div>
            </div>
            <div className="mkt-card reveal-right">
              <div className="mkt-card-head">
                <i className="fas fa-map-marker-alt"></i>
                <h3>Telangana</h3>
              </div>
              <div className="mkt-card-body">
                <div className="mkt-row">
                  <span className="mkt-row-label">Commercial Vehicles</span>
                  <span className="mkt-row-val">25K <i className="fas fa-long-arrow-alt-right"></i> 31K units</span>
                </div>
                <div className="mkt-row">
                  <span className="mkt-row-label">Construction Equipment</span>
                  <span className="mkt-row-val">600 <i className="fas fa-long-arrow-alt-right"></i> 840 units</span>
                </div>
                <div className="mkt-total">
                  <span>Total Value</span>
                  <strong>&#8377;2,150 Cr → &#8377;2,690 Cr</strong>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* ── LOCATIONS ── */}
      <section className="sec loc-sec" id="fp-loc">
        <div className="wrap">
          <div className="sec-header centered reveal">
            <span className="sec-eyebrow">Locations</span>
            <h2 className="sec-title">Franchise opportunities <em>across AP & Telangana</em></h2>
          </div>
          <p className="loc-desc reveal">
            Explore prime franchise opportunities with our comprehensive support.
            Digital + Field Service Combo for the Used Commercial Vehicle Market.
          </p>
          <div className="loc-grid">
            <div className="reveal-left">
              <div className="loc-col-title">
                <i className="fas fa-map-marked-alt"></i>
                <h3>Andhra Pradesh</h3>
                <span className="loc-count">15 Cities</span>
              </div>
              <div className="loc-pills">
                {['Srikakulam','Vijayanagaram','Vishakhapatnam','Rajahmundry','Kakinada','Ellur',
                  'Vijayawada','Guntur','Ongole','Nellore','Kadapa','Chitoor','Ananthapuram','Kurnool'
                ].map((c) => <span className="loc-pill" key={c}>{c}</span>)}
              </div>
            </div>
            <div className="reveal-right">
              <div className="loc-col-title">
                <i className="fas fa-map-marked-alt"></i>
                <h3>Telangana</h3>
                <span className="loc-count">11 Cities</span>
              </div>
              <div className="loc-pills">
                {['Hyderabad (3 Locations)','Karimnagar','Warangal','Nizamabad','Adilabad',
                  'Zaheerabad','Mahabubnagar','Khammam','Bhadrachalam','Kodad'
                ].map((c) => <span className="loc-pill" key={c}>{c}</span>)}
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* ── MODELS ── */}
      <section className="sec mod-sec" id="fp-mod">
        <div className="wrap">
          <div className="sec-header centered reveal">
            <span className="sec-eyebrow">Franchise Models</span>
            <h2 className="sec-title">Choose your <em>franchise model</em></h2>
            <p className="sec-sub">
              Three distinct models for different market sizes, each with strong ROI potential and 10-12 month break-even.
            </p>
          </div>
          <div className="mod-grid">
            <div className="mod-card reveal s1">
              <div className="mod-top">
                <div className="mod-top-icon"><i className="fas fa-crown"></i></div>
                <h3>Flagship Model</h3>
                <span>Metro Markets</span>
              </div>
              <div className="mod-body">
                <ul className="mod-list">
                  <li>800-1000 sqft office space</li>
                  <li>Full setup: Office + Auction + Workshop</li>
                  <li>4-6 sales staff + 1 admin</li>
                  <li>Up to 24 revenue streams</li>
                  <li>3-5 year lock-in</li>
                </ul>
              </div>
              <div className="mod-foot">
                <div className="mod-roi">
                  <strong>300% ROI</strong>
                  <span>Maximum returns for metro locations</span>
                </div>
              </div>
            </div>
            <div className="mod-card featured reveal s2">
              <div className="mod-tag">Recommended</div>
              <div className="mod-top">
                <div className="mod-top-icon"><i className="fas fa-building"></i></div>
                <h3>Standard Model</h3>
                <span>City Markets</span>
              </div>
              <div className="mod-body">
                <ul className="mod-list">
                  <li>600-800 sqft office space</li>
                  <li>Office + Auction setup</li>
                  <li>3-4 sales staff + 1 admin</li>
                  <li>Up to 12 revenue streams</li>
                  <li>3 year lock-in</li>
                </ul>
              </div>
              <div className="mod-foot">
                <div className="mod-roi">
                  <strong>250% ROI</strong>
                  <span>Balanced investment for city markets</span>
                </div>
              </div>
            </div>
            <div className="mod-card reveal s3">
              <div className="mod-top">
                <div className="mod-top-icon"><i className="fas fa-store-alt"></i></div>
                <h3>Compact Model</h3>
                <span>Town Markets</span>
              </div>
              <div className="mod-body">
                <ul className="mod-list">
                  <li>400-600 sqft office space</li>
                  <li>Office-only setup</li>
                  <li>1-2 sales staff + 1 admin</li>
                  <li>Up to 6 revenue streams</li>
                  <li>3 year lock-in</li>
                </ul>
              </div>
              <div className="mod-foot">
                <div className="mod-roi">
                  <strong>200% ROI</strong>
                  <span>Lean operations for town markets</span>
                </div>
              </div>
            </div>
          </div>
          <div className="perf-row">
            <div className="perf-item reveal-left">
              <i className="fas fa-chart-bar"></i>
              <div>
                <h4>Consistent Performance</h4>
                <p>All models achieve break-even within 10-12 months, ensuring predictable returns across market sizes.</p>
              </div>
            </div>
            <div className="perf-item reveal-right">
              <i className="fas fa-expand-arrows-alt"></i>
              <div>
                <h4>Scalable Operations</h4>
                <p>From compact town operations to flagship city centers, each model optimizes space and staffing for maximum efficiency.</p>
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* ── SUPPORT ── */}
      <section className="sec sup-sec" id="fp-sup">
        <div className="wrap">
          <div className="sec-header centered reveal">
            <span className="sec-eyebrow">Support</span>
            <h2 className="sec-title">Company <em>support</em></h2>
            <p className="sec-sub">Comprehensive support to ensure your franchise success from day one</p>
          </div>
          <div className="sup-grid">
            <div className="sup-col reveal s1">
              <div className="sup-col-head">
                <i className="fas fa-bullhorn"></i>
                <h4>Offline Marketing Collaterals</h4>
              </div>
              <div className="sup-col-body">
                <ul>
                  <li>Standees</li><li>Canopy</li><li>Leaflets</li>
                  <li>Pens & Dairies</li><li>Calanders</li><li>Bags</li>
                  <li>Water Bottles</li><li>Cups</li><li>Auction Stickers</li>
                  <li>Stickers Regular</li><li>Local Branding (Name Boards)</li>
                </ul>
              </div>
            </div>
            <div className="sup-col reveal s2">
              <div className="sup-col-head">
                <i className="fas fa-tshirt"></i>
                <h4>Promotional Merchandise</h4>
              </div>
              <div className="sup-col-body">
                <ul><li>Umbrella</li><li>T-Shirts</li><li>Caps</li></ul>
              </div>
            </div>
            <div className="sup-col reveal s3">
              <div className="sup-col-head">
                <i className="fas fa-laptop-code"></i>
                <h4>Digital & Launch Support</h4>
              </div>
              <div className="sup-col-body">
                <ul>
                  <li>Digital Marketing</li><li>Seasonal Marketing</li>
                  <li>Media Support</li><li>Marketing Vehicle Support</li>
                  <li>Launch Support</li>
                  <li>Tech Support (Emails, Website, Software-APP)</li>
                  <li>Setup Guidelines</li>
                </ul>
              </div>
            </div>
            <div className="sup-col reveal s4">
              <div className="sup-col-head">
                <i className="fas fa-users-cog"></i>
                <h4>Operational / HR Support</h4>
              </div>
              <div className="sup-col-body">
                <ul><li>HRMS</li><li>Training</li><li>Location Survey</li><li>Onboarding</li></ul>
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* ── INVESTMENT ── */}
      <section className="sec inv-sec" id="fp-inv">
        <div className="wrap">
          <div className="sec-header centered reveal">
            <span className="sec-eyebrow">Investment</span>
            <h2 className="sec-title">Set up cost & <em>franchise fee</em></h2>
            <p className="sec-sub">Transparent investment structure designed for sustainable growth</p>
          </div>
          <div className="inv-grid">
            <div className="inv-card reveal s1">
              <div className="inv-icon"><i className="fas fa-building"></i></div>
              <div className="inv-amount">&#8377;5,00,000</div>
              <h3>Set-Up Cost</h3>
              <p>Covers interiors, branding, reception, workstations, display screens, signage. Varies for 3 models.</p>
            </div>
            <div className="inv-card reveal s2">
              <div className="inv-icon"><i className="fas fa-file-contract"></i></div>
              <div className="inv-amount">&#8377;1,50,000</div>
              <h3>Rental Advance & Compliance</h3>
              <p>Covers office rental deposit, local licenses, and statutory compliance.</p>
            </div>
            <div className="inv-card reveal s3">
              <div className="inv-icon"><i className="fas fa-award"></i></div>
              <div className="inv-amount">&#8377;5,00,000</div>
              <h3>Franchise Fee (One-time)</h3>
              <p>Covers brand rights, training, onboarding, and digital platform access.</p>
            </div>
          </div>
          <div className="inv-ongoing reveal">
            <h3>Ongoing Costs</h3>
            <ul className="inv-ongoing-items">
              <li><i className="fas fa-home"></i> Monthly office rent (~&#8377;35K–50K for 400–600 sqft)</li>
              <li><i className="fas fa-user-tie"></i> Salaries for 2–3 staff</li>
              <li><i className="fas fa-wifi"></i> Utility & digital subscriptions</li>
            </ul>
          </div>
        </div>
      </section>

      {/* ── CTA ── */}
      <section className="sec cta-sec" id="fp-cta">
        <div className="wrap">
          <div className="sec-header centered reveal">
            <span className="sec-eyebrow">Get Started</span>
            <h2 className="sec-title">Let's build the future of <em>mobility commerce — together</em></h2>
          </div>
          <p className="cta-msg reveal">
            We're excited about the opportunity to transform the used vehicle and equipment
            resale industry with trust, transparency, and technology.
          </p>
          <p className="cta-sub reveal">We look forward to your support in driving this vision forward.</p>
          <div className="cta-btns reveal">
            <a href="mailto:pranay.kumar@vahaanbazar.com" className="btn btn-white">
              <i className="fas fa-envelope"></i> Email Us
            </a>
            <a href="tel:+919840469298" className="btn btn-outline-w">
              <i className="fas fa-phone-alt"></i> Call Us
            </a>
          </div>
          <div className="cta-cards reveal">
            <div className="cta-card">
              <i className="fas fa-envelope"></i>
              <div>
                <small>Email</small>
                <a href="mailto:pranay.kumar@vahaanbazar.com">pranay.kumar@vahaanbazar.com</a><br />
                <a href="mailto:shameer.shaik@vahaanbazar.com">shameer.shaik@vahaanbazar.com</a>
              </div>
            </div>
            <div className="cta-card">
              <i className="fas fa-phone-alt"></i>
              <div>
                <small>Call Us</small>
                <span>9840469298</span><br /><span>9640234886</span>
              </div>
            </div>
            <div className="cta-card">
              <i className="fas fa-thumbs-up"></i>
              <div>
                <small>Social Media</small>
                <span>@vahaanbazar</span>
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* ── FOOTER ── */}
      <footer className="foot">
        <div className="foot-inner">
          <div className="foot-brand">
            <img src="https://vahaan-buy-and-sell-category-images.s3.ap-south-1.amazonaws.com/VahaanBazar_Image.png" alt="VahaanBazar" />
            <p>India's Complete Used Automobile Marketplace — Franchise Opportunities</p>
            <div className="foot-apps">
              <a href="https://play.google.com/store/apps/details?id=com.vahaanbazar.app" target="_blank" rel="noopener noreferrer">
                <i className="fab fa-google-play"></i> Google Play
              </a>
              <a href="https://apps.apple.com/in/app/vahaanbazar/id6753955870" target="_blank" rel="noopener noreferrer">
                <i className="fab fa-apple"></i> App Store
              </a>
            </div>
          </div>
          <div className="foot-col">
            <h4>Contact</h4>
            <p><i className="fas fa-envelope"></i> <a href="mailto:pranay.kumar@vahaanbazar.com">pranay.kumar@vahaanbazar.com</a></p>
            <p><i className="fas fa-phone-alt"></i> <a href="tel:+919840469298">+91 9840469298</a></p>
            <p><i className="fas fa-globe"></i> <a href="https://www.vahaanbazar.com" target="_blank" rel="noopener noreferrer">www.vahaanbazar.com</a></p>
            <p><i className="fas fa-map-marker-alt"></i> Hyderabad, India</p>
          </div>
          <div className="foot-col">
            <h4>Follow Us</h4>
            <div className="foot-socials">
              <a href="https://linkedin.com" target="_blank" rel="noopener noreferrer"><i className="fab fa-linkedin-in"></i></a>
              <a href="https://instagram.com" target="_blank" rel="noopener noreferrer"><i className="fab fa-instagram"></i></a>
              <a href="https://facebook.com" target="_blank" rel="noopener noreferrer"><i className="fab fa-facebook-f"></i></a>
              <a href="https://twitter.com" target="_blank" rel="noopener noreferrer"><i className="fab fa-twitter"></i></a>
              <a href="https://youtube.com" target="_blank" rel="noopener noreferrer"><i className="fab fa-youtube"></i></a>
            </div>
          </div>
        </div>
        <div className="foot-bar">
          <p>&copy; 2026 Vahaan Bazar Private Limited. All Rights Reserved.</p>
          <div>
            <a href="/privacy-policy">Privacy Policy</a>
            <a href="/terms-and-conditions">Terms of Service</a>
          </div>
        </div>
      </footer>
    </div>
  );
}

export default FranchisePage;
